import { Box, Flex, Grid, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import logoSvg from '../../../../../assets/logo.svg'
import checkIcon from '../../../../../assets/checkIcon.png'
import { ConsumedEnergyIcon } from '../../../../../assets/icons/ConsumedEnergy'
import { KILOWATT_HOUR } from '../../../../../utils/consts'
import { formatDate } from '../../../../../utils/helpers'
import CostForConsumptionIcon from '../../../../../assets/icons/CostConsumptionIcon'
import { CardPdf } from '../EnergyReportComponents/CardComponentPdf'
import { getLocationsPercentages } from '../EnergyConsumptionReportPdf'

type Props = {
  locations: any
  startDate: any
  data: any
  endDate: any
}

export const BillingTableTitle = ({ locations, data, startDate, endDate }: Props) => {

  return (
    <Box
      border={'solid: 2px'}
      gap="60px"
      height="100%"
      width="100%"
      display="flex"
      alignItems="center"
      flexDirection="column"
      textAlign="center"
      pt={20}
    >
      <Flex direction="column" alignItems="center" gap={7}>
        <Flex direction="column" alignItems="center" gap={2}>
          <Stack height="fit-content">
            <Text
              fontSize="38px"
              fontWeight="700"
              fontFamily='Inter'
              color="#484848"
              align="center"
              m={0}
              p={0}
            >
              {`${formatDate(startDate)} - ${formatDate(endDate)}`}
            </Text>
          </Stack>
          <Text fontSize="20px" fontWeight={400} color="#484848" fontFamily="Inter">
            Billing Report
          </Text>
          <Flex gap={3} wrap="wrap" width="90%" justifyContent="center">
            {locations?.map((location) => (
              <Flex
                key={location.id}
                border="1px solid #157FEE"
                borderRadius="full"
                p="3px 20px"
                sx={{ bgcolor: 'red' }}
                bg="#E8EEFD"
                alignItems="center"
                justifyContent="center"
                m="0px"
              >
                <img
                  src={checkIcon}
                  alt="icon"
                  style={{ width: '20px', height: '20px', alignSelf: 'center' }}
                />
                <Text
                  className={'locationName'}
                  fontWeight="700"
                  fontSize="20px"
                  fontFamily="Inter"
                  color="#157FEE"
                >
                  {location.title}
                </Text>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
      <Flex direction="column" fontSize={20} fontWeight={700} gap={5} mb="160px">
        <Grid templateColumns="repeat(2, 300px)" gap={2}>
          <CardPdf
            width="100%"
            title="Total consumed energy"
            measurementType={KILOWATT_HOUR}
            value={data.totalConsumption}
            percentageChange={getLocationsPercentages(data.totalConsumption, data.prevConsumption)}
          >
            <ConsumedEnergyIcon boxSize="20px" color="text.secondary" />
          </CardPdf>
          <CardPdf
            width="100%"
            title="Cost for consumed energy"
            measurementType="лв"
            value={data.consumptionCost}
            percentageChange={getLocationsPercentages(data.consumptionCost, data.prevCost)}
          >
            <CostForConsumptionIcon boxSize="20px" color="text.secondary" />
          </CardPdf>
        </Grid>
      </Flex >
      <Stack mb="100px">
        <img src={logoSvg} alt="logo" />
      </Stack>
    </Box >
  )
}
